import { keyframes } from '@emotion/react';
import { Box, ThemeUICSSObject } from 'theme-ui';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

// Inline ring spinner. Same look as the loader.png ring used by LoaderSpinner,
// drawn with theme colours so it sits in text and buttons at any size.
// Give it a label when it stands alone. Inside a role="status" region that
// already has text, leave the label off so screen readers hear one message.
const Spinner = ({
  size = 16,
  label,
  sx,
}: {
  size?: number;
  label?: string;
  sx?: ThemeUICSSObject;
}): JSX.Element => (
  <Box
    role={label ? 'status' : undefined}
    aria-label={label}
    aria-hidden={label ? undefined : true}
    sx={{
      display: 'inline-block',
      flexShrink: 0,
      width: size,
      height: size,
      borderRadius: '50%',
      border: `${Math.max(2, Math.round(size / 8))}px solid`,
      borderColor: 'backgroundMedium',
      borderTopColor: 'secondaryBackground',
      animation: `${spin} 1s linear infinite`,
      '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      ...sx,
    }}
  />
);

export default Spinner;
